import { ExportColumn, ExportStyles, TcsTdsOption } from '../types';

export const salesExportColumns: ExportColumn[] = [
  { header: 'Invoice Date', accessor: 'invoice_date', formatType: 'date' },
  { header: 'Invoice No', accessor: 'invoice_no', formatType: 'text' },
  { header: 'Customer Name', accessor: 'customer_name', formatType: 'text' },
  { header: 'Customer Legal Name', accessor: 'customer_legal_name', formatType: 'text' },
  { header: 'Taxabillity', accessor: 'invoice_taxability', formatType: 'text' },
  { header: 'Customer Category', accessor: 'customer_category', formatType: 'text' },
  { header: 'Customer GSTIN', accessor: 'customer_gstin', formatType: 'text' },
  { header: 'Place of Supply', accessor: 'place_of_supply', formatType: 'text' },
  { header: 'Billing Currency', accessor: 'billing_currency', formatType: 'currency_name' },
  { header: 'Taxable Value', accessor: 'taxable_value', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'IGST Rate', accessor: 'igst_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'IGST Amount', accessor: 'igst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'CGST Rate', accessor: 'cgst_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'CGST Amount', accessor: 'cgst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'SGST/UTGST Rate', accessor: 'sgst_utgst_rate', formatType: 'number' , cellStyle: 'custonCurrenctStyle'},
  { header: 'SGST/UTGST Amount', accessor: 'sgst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'Cess Rate', accessor: 'cess_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'Cess Amount', accessor: 'cess_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: '(-)Additional Discount', accessor: 'additional_discount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'TCS Amount', accessor: 'tcs_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Round Off', accessor: 'round_off', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Total GST Amount', accessor: 'total_gst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Gross invoice value', accessor: 'gross_invoice_value', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Net Amount', accessor: 'net_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Status', accessor: 'status', formatType: 'text' },
  // { header: 'Invoice Amount', accessor: 'invoice_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Due Date', accessor: 'due_date', formatType: 'date' },
  { header: 'Due in Overdue Days', accessor: 'due_in_overdue_days', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
];
export const purchaseExportColumns: ExportColumn[] = [
  { header: 'Entry Date', accessor: 'invoice_date', formatType: 'date' },
  { header: 'Voucher No', accessor: 'invoice_no', formatType: 'text' },
  { header: 'Supplier Name', accessor: 'customer_name', formatType: 'text' },
  { header: 'Status', accessor: 'customer_legal_name', formatType: 'text' },
  { header: 'Due Date', accessor: 'invoice_taxability', formatType: 'date' },
  { header: 'Amount', accessor: 'customer_category', formatType: 'currency' },
  { header: 'Inv. Net Due', accessor: 'customer_gstin', formatType: 'text' },
  { header: 'Due in/Over Due', accessor: 'place_of_supply', formatType: 'text' },
  { header: 'Supplier Invoice Date', accessor: 'billing_currency', formatType: 'date' },
  { header: 'Supplier Invoice', accessor: 'taxable_value', formatType: 'text' },
];
export const creditExportColumns: ExportColumn[] = [
  { header: 'Credit Note Date', accessor: 'invoice_date', formatType: 'date' },
  { header: 'Credit Note No', accessor: 'invoice_no', formatType: 'text' },
  { header: 'Party Invoice', accessor: 'customer_name', formatType: 'text' },
  { header: 'Party Name', accessor: 'customer_legal_name', formatType: 'text' },
  { header: 'Status', accessor: 'invoice_taxability', formatType: 'text' },
  { header: 'Due Date', accessor: 'customer_category', formatType: 'date' },
  { header: 'Amount', accessor: 'customer_gstin', formatType: 'currency' },
  { header: 'Due in/Over Due', accessor: 'place_of_supply', formatType: 'text' },
];
export const debitExportColumns: ExportColumn[] = [
  { header: 'Debit Note Date', accessor: 'invoice_date', formatType: 'date' },
  { header: 'Debit Note No', accessor: 'invoice_no', formatType: 'text' },
  { header: 'Party Invoice', accessor: 'customer_name', formatType: 'text' },
  { header: 'Party Name', accessor: 'customer_legal_name', formatType: 'text' },
  { header: 'Status', accessor: 'invoice_taxability', formatType: 'text' },
  { header: 'Due Date', accessor: 'customer_category', formatType: 'date' },
  { header: 'Amount', accessor: 'customer_gstin', formatType: 'currency' },
  { header: 'Due in/Over Due', accessor: 'place_of_supply', formatType: 'text' },
];
export const tdsExportColumns: ExportColumn[] = [
  { header: 'Date of deduction', accessor: 'invoicedate', formatType: 'date', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher No', accessor: 'vouchernumber', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher Type', accessor: 'vouchertype', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Party Name', accessor: 'suppliername', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'PAN Number', accessor: 'pan_number', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Legal Entity', accessor: 'legalentity', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Taxable Amount', accessor: 'deductedamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TDS(%)', accessor: 'tdspercentage', formatType: 'number', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TDS Amount', accessor: 'tdsamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  {
    header: 'Amount After TDS',
    accessor: 'amountaftertds',
    formatType: 'currency',
    headerStyle: 'header',
    cellStyle: 'custonCurrenctStyle',
  },
  { header: 'TDS Details', accessor: 'tdsdetails', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
];

export const tcsExportColumns: ExportColumn[] = [
  { header: 'Date of deduction', accessor: 'invoicedate', formatType: 'date', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher No', accessor: 'vouchernumber', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher Type', accessor: 'vouchertype', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Party Name', accessor: 'suppliername', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'PAN Number', accessor: 'pan_number', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Legal Entity', accessor: 'legalentity', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Taxable Amount', accessor: 'deductedamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TCS(%)', accessor: 'tdspercentage', formatType: 'number', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TCS Amount', accessor: 'tdsamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  {
    header: 'Amount After TCS',
    accessor: 'amountaftertds',
    formatType: 'currency',
    headerStyle: 'header',
    cellStyle: 'custonCurrenctStyle',
  },
  { header: 'TCS Details', accessor: 'tdsdetails', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
];

export const posExportColumns: ExportColumn[] = [
  { header: 'Date', accessor: 'invoice_date', formatType: 'date', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Invoice No', accessor: 'invoice_no', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Customer Name', accessor: 'customer_name', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Phone Number', accessor: 'phone_number', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Invoice Amount', accessor: 'net_amount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'Status', accessor: 'status', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
];

export const exportFormats = ['excel', 'csv'] as const;

export const tcsAndTdsOptions: TcsTdsOption[] = [
  { value: 'TCSPAY', label: 'TCS Payable' },
  { value: 'TCSREC', label: 'TCS Receivable' },
  { value: 'TDSPAY', label: 'TDS Payable' },
  { value: 'TDSREC', label: 'TDS Receivable' },
];

export const defaultExportStyles: ExportStyles = {
  header: {
    fontSize: 14,
    alignment: 'center',
    style: 'bold',
    color: '#000000',
  },
  body: {
    fontSize: 12,
    alignment: 'left',
    style: 'normal',
    color: '#333333',
  },
  custom: {
    fontSize: 32,
    alignment: 'center',
    style: 'bold',
    color: '#c90000ff',
  },
  customHead: {
    fontSize: 2,
    alignment: 'right',
    style: 'italic',
    color: '#24c239ff',
  },
  custonCurrenctStyle: {
    fontSize: 12,
    alignment: 'right',
    style: 'normal',
    color: '#333333',
  },
} as const;
